import React from 'react';

const EmailInput = ({ value, onChange }) => {
  return (
    <input
      type="email"
      value={value}
      onChange={onChange}
      className="w-full p-2 border border-gray-300 rounded"
      placeholder="Email"
      required
    />
  );
};

export default EmailInput;